// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function container(theme) {
  var match = theme.components;
  var downloadAppsBanner = match.downloadAppsBanner;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.backgroundColor(downloadAppsBanner.backgroundColor),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0)),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(500)),
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.overflow("hidden"),
              Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
              BsCssJs$PrezzeeRibbon.color(downloadAppsBanner.color),
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(1.0)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(1.0)),
              BsCssJs$PrezzeeRibbon.position("relative"),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
                    BsCssJs$PrezzeeRibbon.flexDirection("column"),
                    BsCssJs$PrezzeeRibbon.justifyContent("center")
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
                    BsCssJs$PrezzeeRibbon.position("relative"),
                    BsCssJs$PrezzeeRibbon.backgroundImage("none")
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [
                    BsCssJs$PrezzeeRibbon.flexDirection("row"),
                    BsCssJs$PrezzeeRibbon.justifyContent("flexStart")
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreen, [BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(940))]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(750))]),
              BsCssJs$PrezzeeRibbon.selector("& > .fresnel-container", [
                    BsCssJs$PrezzeeRibbon.position("absolute"),
                    BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.zero),
                    BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
                    BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))
                  ]),
              BsCssJs$PrezzeeRibbon.selector("& > .fresnel-container > img", [
                    BsCssJs$PrezzeeRibbon.position("absolute"),
                    BsCssJs$PrezzeeRibbon.height("auto"),
                    BsCssJs$PrezzeeRibbon.zIndex(1),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
                    BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pct(100)),
                    BsCssJs$PrezzeeRibbon.width("auto"),
                    BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.zero),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.px(-60))]),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.px(-160))]),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [
                          BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                          BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
                          BsCssJs$PrezzeeRibbon.height("auto"),
                          BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
                          BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateX(BsCssJs$PrezzeeRibbon.pct(-50)))
                        ])
                  ])
            ]);
}

var contentContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.zIndex(2),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.pct(8.0))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mediaRange(Theme__Responsive$PrezzeeRibbon.smallScreenBreakpoint, Theme__Responsive$PrezzeeRibbon.tabletBreakpoint), [
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.pct(4.0)),
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(60.0))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(0)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0))
          ])
    ]);

var Styles = {
  container: container,
  contentContainer: contentContainer
};

function DownloadAppsBanner__Container(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: contentContainer
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      greaterThanOrEqual: "rbSmallScreen",
                      children: props.background
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      lessThan: "rbSmallScreen",
                      children: props.mobileBackground
                    })
              ],
              className: container(theme)
            });
}

var make = DownloadAppsBanner__Container;

export {
  Styles ,
  make ,
}
/* contentContainer Not a pure module */
